var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLickingFurPulling = function SvgLickingFurPulling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M32.94 4.56c15.24 0 27.6 12.36 27.6 27.6s-12.36 27.6-27.6 27.6-27.6-12.36-27.6-27.6 12.36-27.6 27.6-27.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00686A",
    d: "M40.057 6.89c-2.848-7.853-12.537-7.853-15.384 0-6.632-4.526-15.198 2.112-10.15 11.888 1.218 2.356 2.745 3.96 4.364 4.927a368 368 0 0 0-.76 11.427c-1.822 21.073 30.271 21.076 28.475 0a368 368 0 0 0-.76-11.427c1.62-.967 3.147-2.571 4.364-4.927 5.05-9.775-3.517-16.414-10.15-11.889"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#008C95",
    d: "M37.941 3.42c-3.221-.115-6.493 1.846-7.957 5.883-6.632-4.525-15.2 2.113-10.15 11.889 1.217 2.355 2.745 3.96 4.364 4.926a368 368 0 0 0-1.139 21.738c-3.304-2.598-5.336-6.831-4.931-12.724.26-3.792.445-7.605.76-11.428-1.62-.966-3.147-2.57-4.364-4.926-5.05-9.775 3.517-16.414 10.15-11.889C27.008.446 33.95-.71 37.94 3.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57557",
    d: "M32.365 19.371c8.388 0 12.583 11.505 6.581 14.543-3.058 1.548-6.367-.547-6.581-.688-.216.14-3.525 2.236-6.583.688-6.002-3.038-1.807-14.543 6.583-14.543"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F99C86",
    d: "M38.031 21.42c-8.354-1.988-14.14 8.354-10.225 13.046a5.3 5.3 0 0 1-2.024-.552c-6.002-3.038-1.807-14.543 6.583-14.543 2.22 0 4.145.805 5.666 2.048"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57557",
    d: "M45.043 11c5.21 2.659-1.11 9.079-3.906 7.652C38.35 17.229 39.83 8.339 45.043 11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F99C86",
    d: "M46.133 11.756c-3.453-.555-4.712 4.596-3.54 7.044-.531.104-1.033.067-1.456-.148C38.35 17.229 39.83 8.339 45.043 11q.664.341 1.09.755"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57557",
    d: "M32.365 6.016c6.273 0 3.355 9.206 0 9.206-3.365 0-6.268-9.206 0-9.206"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F99C86",
    d: "M32.644 15.202c-3.502.507-6.702-9.186-.279-9.186 1.441 0 2.397.485 2.974 1.233a6 6 0 0 0-.56-.026c-4.833 0-4.213 5.472-2.135 7.979"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57557",
    d: "M19.687 11c5.214-2.661 6.693 6.229 3.905 7.652-2.796 1.427-9.114-4.993-3.905-7.652"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F99C86",
    d: "M22.229 18.82c-2.997-.49-7.01-5.537-2.542-7.818 1.868-.954 3.257-.424 4.143.714-.52.017-1.097.17-1.73.493-3.287 1.677-1.984 4.853.128 6.61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M46.94 43.773q.139 5.034.14 10.034c-4.759 2.015-10.209.929-13.639-3.22.074-.442.866-4.731 5.025-6.83 4.156-2.096 8.073-.188 8.474.016"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M47.08 53.808q0 1.598-.013 3.193h-29.41v-1.519c.49-.807 2.607-4.098 6.979-5.446 4.35-1.34 7.94.162 8.805.553a99 99 0 0 0 13.638 3.22"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M22.96 57h-5.304v-1.518c.425-.7 2.07-3.264 5.347-4.812a373 373 0 0 0-.042 6.33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M18.127 35.13a93.5 93.5 0 0 0 14.237 7.879c-.815 8.94-14.098 9.508-14.575.765q.117-4.311.338-8.643"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.38 38.42c-.009.22-.01.437-.016.65-.1 3.793-.297 7.743-.346 10.812-2.727-.54-5.035-2.556-5.229-6.108q.117-4.311.338-8.643a94 94 0 0 0 5.254 3.289"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M46.601 35.13q.22 4.334.338 8.644A94.8 94.8 0 0 1 17.656 55.48c-.01-2.446-.001-4.9.039-7.36 10.168-2.634 19.909-6.936 28.906-12.99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M23.09 46.553c-.012.434-.117 6.405-.123 7.614a96 96 0 0 1-5.311 1.315c-.01-2.447-.001-4.9.039-7.36a95 95 0 0 0 5.395-1.57"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M17.79 43.775a95 95 0 0 0 5.037 2.863 94 94 0 0 1-5.132 1.485q.035-2.171.095-4.348"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00686A",
    d: "M47 63v-6H18v6z"
  })));
};
export default SvgLickingFurPulling;